import { makeStyles } from '@mui/styles';
import BarChart from 'apollo-react/components/BarChart';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSavedSearchResults } from '../../../../actions/SavedSearchResultsActions';
import withTranslation from '../../../../components/withTranslation';
import { getSavedSearchResultsKey } from '../../../../reducers/SavedSearchResultsReducer';

const useStyles = makeStyles({
  container: { padding: 16 },
});

const getChartData = (rows, groupBy) => {
  const data = rows.reduce((acc, curr) => {
    const groupByValue = curr[groupBy];

    acc[groupByValue] = acc[groupByValue] ? acc[groupByValue] + 1 : 1;

    return acc;
  }, {});

  return Object.keys(data)
    .map((key) => ({ key, count: data[key] }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 7);
};

const DashboardPartBarChart = ({ tab, translateString }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const savedSearchResults = useSelector((state) => state.savedSearchResults);
  const {
    groupBy,
    savedSearchByEntity: { entityName, savedSearchName },
  } = tab.graph;

  const results = _.get(savedSearchResults, [
    getSavedSearchResultsKey(entityName, savedSearchName),
    'results',
  ]);
  const rows = results?.rows;

  const [chartData, setChartData] = useState();

  useEffect(() => {
    dispatch(getSavedSearchResults({ entityName, searchName: savedSearchName }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedSearchName]);

  useEffect(() => {
    if (rows) {
      setChartData(getChartData(rows, groupBy));
    }
  }, [rows, groupBy]);

  function renderChart() {
    if (!chartData) {
      return `${translateString('Loading')}...`;
    }
    if (chartData.length === 0) {
      return translateString('No data available');
    }

    return <BarChart height={350} data={chartData} />;
  }

  return <div className={classes.container}>{renderChart()}</div>;
};

export default withTranslation(DashboardPartBarChart);
